// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************


// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =====================================================================================================================
// Splide
// =====================================================================================================================

//import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
    const tabTriggers = document.querySelectorAll('[data-bs-toggle="tab"]');
    tabTriggers.forEach((tabTrigger) => {
        //console.log(tabTrigger);
        tabTrigger.addEventListener('shown.bs.tab', (event) => {
            console.log('Tab shown event triggered');
            const targetSelector = event.target.getAttribute('data-bs-target') || event.target.getAttribute('href');
            if (!targetSelector) return;

            const tabPane = document.querySelector(targetSelector);
            if (!tabPane) return;

            const splideElements = tabPane.querySelectorAll('.splide');
            splideElements.forEach((splideEl) => {
                if (splideEl.splide) {
                    splideEl.splide.refresh();
                }
            });
        });
    });
});

// Stop Videos on Modal Close
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.video-modal').forEach(function (modal) {
        modal.addEventListener('hide.bs.modal', function (e) {
            let originalSrc = modal.querySelector('iframe').src;
            //console.log( originalSrc );
            modal.querySelector('iframe').src = originalSrc;
        });
    });
});


// Result numbers in Dealer Locator
function renumberDealerLocatorResults() {
    document.querySelectorAll('.custom-marker').forEach(function (el, i) {
        const oldNum = el.querySelector('.dealer-marker-num');
        if (oldNum) oldNum.remove();

        const span = document.createElement('span');
        span.className = 'dealer-marker-num';
        span.textContent = i + 1;
        el.appendChild(span);
    });

    document.querySelectorAll('#wpsl-stores ul li').forEach(function (el, i) {
        const resultNum = el.querySelector('.result-num');
        if (resultNum && resultNum.textContent !== String(i + 1)) {
            resultNum.textContent = i + 1;
        }
    });
}

window.addEventListener('load', function () {
    const stores = document.querySelector('#wpsl-stores');
    if (!stores) {
        renumberDealerLocatorResults();
        return;
    }

    let observer;

    const runRenumbering = function () {
        if (observer) observer.disconnect();
        renumberDealerLocatorResults();
        if (observer) {
            observer.observe(stores, {
                childList: true,
                subtree: true
            });
        }
    };

    runRenumbering();

    observer = new MutationObserver(function () {
        runRenumbering();
    });

    observer.observe(stores, {
        childList: true,
        subtree: true
    });
});

/* Adding .scrolled class to nav bar to change background color on scroll */
const nav = document.getElementById("main-nav");
window.addEventListener("scroll", function() {
    if (document.scrollingElement.scrollTop > 10) {
        nav.classList.add("scrolled");
    } else {
        nav.classList.remove("scrolled");
    }
});


document.addEventListener('DOMContentLoaded', function() {
    // --------------------- Form Assembly Presets on Page Load ---------------------
    if (window.location.hostname.includes('trailmarshal.com')){
        let contactUsFrame = document.querySelector('#faContactUs');
        if( contactUsFrame ){
            const url = new URL(contactUsFrame.src);
            url.searchParams.set('tfa_35', window.location.origin);
            contactUsFrame.src = url.toString();
        }
        console.log(contactUsFrame);
    }
});

// =====================================================================================================================
// Ketch Footer Modal
// =====================================================================================================================
document.addEventListener('DOMContentLoaded', function () {
    let ketchPrivacy = document.querySelectorAll('.ketch-button a');
    ketchPrivacy.forEach(item => {
        item.addEventListener("click", e => {
            e.preventDefault();
            ketch('showExperience');
        });
    });
});